import Vue from 'vue'
import Router from 'vue-router'

import dakcheckPage from './views/dakcheckPage'
import analysePage from './views/analysePage'
import verbruikPage from './views/verbruikPage'
import gegevensPage from './views/gegevensPage'
import resultatenPage from './views/resultatenPage'

Vue.use(Router)

export default new Router({
  mode: 'abstract',
  routes: [
    {
      path: '/',
      name: 'dakcheck',
      component: dakcheckPage
    },
    {
      path: '/analyse',
      name: 'analyse',
      component: analysePage
    },
    {
      path: '/verbruik',
      name: 'verbruik',
      component: verbruikPage
    },
    {
      path: '/gegevens',
      name: 'gegevens',
      component: gegevensPage
    },
    {
      path: '/resultaten',
      name: 'resultatenPage',
      component: resultatenPage
    },
  ],
})
